import { render, staticRenderFns } from "./eventDiscipline.vue?vue&type=template&id=5d3ee10c"
import script from "./eventDiscipline.vue?vue&type=script&lang=js"
export * from "./eventDiscipline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports